const stats = [
  { value: "700+", label: "福利资源", icon: "ri-database-2-line" },
  { value: "50万+", label: "月活用户", icon: "ri-user-smile-line" },
  { value: "8", label: "福利品类", icon: "ri-stack-line" },
  { value: "98%", label: "用户好评", icon: "ri-thumb-up-line" },
];

export default function StatsSection() {
  return (
    <section className="py-10 md:py-14 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/20">
                <i className={`${stat.icon} text-xl text-background-50`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-background-50/80">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}